import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { loading, isAuthenticated, permissions } = useAuth();

  if (loading) {
    return <div className="loader">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !permissions.includes(requiredPermission)) {
    return (
      <div role="alert" style={{ padding: "2rem" }}>
        You do not have permission to access this page.
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
